import React from 'react';

import DeltaListItem from '/component/base/DeltaListItem/DeltaListItem';

interface EarningTouchableDeltaItemProps {
  item: {
    label: string;
    value: number;
    delta: number;
    period: string;
    onCustomPress?: (() => void) | null;
    testID: string;
  };
}

export const EarningTouchableDeltaItem: React.FC<
  EarningTouchableDeltaItemProps
> = ({item: {label, value, delta, period, onCustomPress, testID}}) => (
  <DeltaListItem
    heading={label}
    headingUseCompetency={true}
    allowFontScaling
    maxFontSizeMultiplier={2}
    subheading={period}
    total={value}
    delta={delta}
    onPress={onCustomPress}
    testID={testID}
  />
);

export default EarningTouchableDeltaItem;
